import Button from "@/component/Button";
import IconQrCode from "@/assets/common/ic_qrcode.svg?react";
import IconLink from "@/assets/common/ic_link.svg?react";

interface OperBtnsProps {
  isPassWord: boolean;
  disabled: boolean;
  handleCopyUrl: () => void;
  handleShowQrCode: () => void;
}

const OperBtns = ({
  isPassWord,
  disabled,
  handleCopyUrl,
  handleShowQrCode,
}: OperBtnsProps) => {
  return (
    <div className="flex items-center justify-center mt-4 mb-6 text-3">
      <Button
        disabled={disabled}
        className={`w-33 h-8 bg-#ECEEF3 b-transparent flex items-center justify-center rounded-2.5 text-#30343C`}
        onClick={handleShowQrCode}
      >
        <IconQrCode className="size-4 mr-1" />
        二维码
      </Button>
      <Button
        disabled={disabled}
        type="primary"
        className={`ml-6 min-w-33 h-8 flex items-center justify-center rounded-2.5 `}
        onClick={handleCopyUrl}
      >
        <IconLink className="size-4 mr-1" />
        {!isPassWord ? "复制链接" : "复制链接和密码"}
      </Button>
    </div>
  );
};

export default OperBtns;
